var MDB = window.MDB || {};
(function ($, global) { 
    MDB.WidgetEditor = MDB.WidgetEditor || {};
    
    $.extend(MDB.WidgetEditor, {
        // required overlap before accepting a drop
        dropzoneRequiredOverlap: 0.60, 
        initDragAnddrop: function (model) {
             
            // init drag&drop
            //make elements draggable
            // target elements with the "draggable" class
            interact('.draggable')
                .draggable({
                    // allow dragging of multple elements at the same time
                    max: 1,//Infinity,

                    // call this function on every dragmove event
                    onmove: function (event) {
                        var target = event.target,
                            // keep the dragged position in the data-x/data-y attributes
                            x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                            y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

                        // translate the element
                        target.style.webkitTransform =
                        target.style.transform =
                            'translate(' + x + 'px, ' + y + 'px)';

                        // update the posiion attributes
                        target.setAttribute('data-x', x);
                        target.setAttribute('data-y', y);
                    },
                    // call this function on every dragend event
                    onend: function (event) {
                        //reset position
                        var target = event.target,
                            x = 0,
                            y = 0;

                        // translate the element
                        target.style.webkitTransform =
                        target.style.transform =
                            'translate(' + x + 'px, ' + y + 'px)';

                        // update the posiion attributes
                        target.setAttribute('data-x', x);
                        target.setAttribute('data-y', y);
                    }
                })
                // enable inertial throwing
                .inertia(true)
                // keep the element within the area of it's parent
                .restrict({
                    //drag: "parent",
                    endOnly: true,
                    elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
                });

            // allow more than one interaction at a time
            interact.maxInteractions(Infinity);

            // setup dropzone
            interact('.dropzone1').dropzone({
                // only accept elements matching this CSS selector
                accept: '.attribute',
                // Require a 75% element overlap for a drop to be possible
                overlap: MDB.WidgetEditor.dropzoneRequiredOverlap,

                // listen for drop related events:

                ondropactivate: function (event) {
                    // add active dropzone feedback
                    event.target.classList.add('drop-active');
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;

                    // feedback the possibility of a drop
                    dropzoneElement.classList.add('drop-target');
                    draggableElement.classList.add('can-drop');
                    //draggableElement.textContent = 'Dragged in';

                },
                ondragleave: function (event) {
                    // remove the drop feedback style
                    event.target.classList.remove('drop-target');
                    event.relatedTarget.classList.remove('can-drop');
                    //event.relatedTarget.textContent = 'Dragged out';
                },
                ondrop: function (event) {
                    //event.relatedTarget.textContent = 'Dropped';
                    // clone etc .. 
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;
                    var de = $(draggableElement);
                    var attrId = de.data('attributeid'),
                        type = de.data('attributetype');

                    draggableElement.classList.remove('can-drop');
                    $('body').trigger('columnattribute-dropped', { attrId: attrId, type: type, dropzoneElement: dropzoneElement, draggableElement: draggableElement });

                },
                ondropdeactivate: function (event) {
                    // remove active dropzone feedback
                    event.target.classList.remove('drop-active');
                    event.target.classList.remove('drop-target');
                }
            });
            

            interact('.dropzone2').dropzone({
                // only accept elements matching this CSS selector
                accept: '.attribute',
                overlap: MDB.WidgetEditor.dropzoneRequiredOverlap,

                // listen for drop related events:
                ondropactivate: function (event) {
                    // add active dropzone feedback
                    event.target.classList.add('drop-active');
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;

                    // feedback the possibility of a drop
                    dropzoneElement.classList.add('drop-target');
                    draggableElement.classList.add('can-drop'); 

                },
                ondragleave: function (event) {
                    // remove the drop feedback style
                    event.target.classList.remove('drop-target');
                    event.relatedTarget.classList.remove('can-drop');
                },
                ondrop: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;

                    var de = $(draggableElement);
                    var attrId = de.data('attributeid'),
                        type = de.data('attributetype');
                    
                    draggableElement.classList.remove('can-drop');
                    
                    $('body').trigger('groupbyattribute-dropped', { attrId: attrId, type: type, dropzoneElement: dropzoneElement, draggableElement: draggableElement });

                },
                ondropdeactivate: function (event) {
                    // remove active dropzone feedback
                    event.target.classList.remove('drop-active');
                    event.target.classList.remove('drop-target');
                }
            });

            // dropzone for collections
            interact('.weditor-collections').dropzone({
                // only accept elements matching this CSS selector
                accept: '.entity',
                // Require a 75% element overlap for a drop to be possible
                overlap: MDB.WidgetEditor.dropzoneRequiredOverlap,

                // listen for drop related events:
                ondropactivate: function (event) {
                    var eid = $(event.relatedTarget).data('entityid');
                    if (model.isAddTableAllowed(eid)) {
                        // add active dropzone feedback
                        event.target.classList.add('drop-active');
                    }
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;

                    // feedback the possibility of a drop
                    dropzoneElement.classList.add('drop-target');
                    draggableElement.classList.add('can-drop');
                },
                ondragleave: function (event) {
                    // remove the drop feedback style
                    event.target.classList.remove('drop-target');
                    event.relatedTarget.classList.remove('can-drop');
                },
                ondrop: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;

                    var de = $(draggableElement);
                    var entityId = de.data('entityid');

                    draggableElement.classList.remove('can-drop');

                    $('body').trigger('collection-dropped', { entityId: entityId, dropzoneElement: dropzoneElement, draggableElement: draggableElement });

                },
                ondropdeactivate: function (event) {
                    // remove active dropzone feedback
                    event.target.classList.remove('drop-active');
                    event.target.classList.remove('drop-target');
                }
            });
        },
        initColumnDropZone:function(element, model) {
            // column dropzone
            interact(element).dropzone({
                // only accept elements matching this CSS selector
                accept: '.attribute',
                // Require a 75% element overlap for a drop to be possible
                overlap: 0.50,

                // listen for drop related events:
                ondropactivate: function (event) {
                    var eid = $(event.relatedTarget).data('attributeid');
                    // add active dropzone feedback
                    event.target.classList.add('drop-active');              
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;

                    // feedback the possibility of a drop
                    dropzoneElement.classList.add('drop-target');
                    draggableElement.classList.add('can-drop');
                },
                ondragleave: function (event) {
                    // remove the drop feedback style
                    event.target.classList.remove('drop-target');
                    event.relatedTarget.classList.remove('can-drop');
                },
                ondrop: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target,
                        dzE = $(dropzoneElement),
                        dgE = $(draggableElement);
                    var attrId = dgE.data('attributeid'),
                        type = dgE.data('attributetype');

                    draggableElement.classList.remove('can-drop');
					
                    if(dzE.hasClass('expression-dropzone')) {
                        dzE.trigger('attribute-dropped', {attrId: attrId, type: type});
                    } else {
                        var groupId = dzE.data('groupnr');
                        $('body').trigger('columnfilter-dropped', { attrId: attrId, type: type, groupId: groupId, dropzoneElement: dropzoneElement, draggableElement: draggableElement });
                    }
					
                },
                ondropdeactivate: function (event) {
                    // remove active dropzone feedback
                    event.target.classList.remove('drop-active');
                    event.target.classList.remove('drop-target');
                }
            });
        },
        initFilterDropZone: function (element, model) {
            // where filters
            interact(element).dropzone({
                // only accept elements matching this CSS selector
                accept: '.attribute',
                // Require a 75% element overlap for a drop to be possible
                overlap: 0.50,

                // listen for drop related events:
                ondropactivate: function (event) {
                    var eid = $(event.relatedTarget).data('attributeid');
                    if (model.isAddTableAllowed(eid)) {
                        // add active dropzone feedback
                        event.target.classList.add('drop-active');
                    }
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;

                    // feedback the possibility of a drop
                    dropzoneElement.classList.add('drop-target');
                    draggableElement.classList.add('can-drop');
                },
                ondragleave: function (event) {
                    // remove the drop feedback style
                    event.target.classList.remove('drop-target');
                    event.relatedTarget.classList.remove('can-drop');
                },
                ondrop: function (event) {                    
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;
                    var de = $(draggableElement);
                    var attrId = de.data('attributeid'),
                        type = de.data('attributetype');
                    var groupId = $(dropzoneElement).data('groupnr');

                    draggableElement.classList.remove('can-drop');
                    $('body').trigger('filterattribute-dropped', { attrId: attrId, type: type, groupId: groupId, dropzoneElement: dropzoneElement, draggableElement: draggableElement });
                },
                ondropdeactivate: function (event) {
                    // remove active dropzone feedback
                    event.target.classList.remove('drop-active');
                    event.target.classList.remove('drop-target');
                }
            });
        },
        initDashboardFilterDropZone: function (model) {
            // where filters
            interact('.dropzone-dashboard-filter').dropzone({
                // only accept elements matching this CSS selector
                accept: '.attribute',
                // Require a 75% element overlap for a drop to be possible
                overlap: 0.25,

                // listen for drop related events:
                ondropactivate: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;
                    var eid = $(draggableElement).data('attributeid');
                    var attr = model.metadata.AttributesById[eid];
                    if (attr) {
                        var dz = $(dropzoneElement);
                        if (dz.hasClass('dz-date')) {
                            // 
                            if (attr.Type == 'Date' || attr.Type == 'DateTime' || attr.Type == 'Date?' || attr.Type == 'DateTime?') {
                                dropzoneElement.classList.add('drop-active');
                            }
                        } else if (dz.hasClass('dz-guid')) {
                            if (attr.Type == 'Guid' || attr.Type == 'Guid?') {
                                dropzoneElement.classList.add('drop-active');
                            }
                        }
                    } else {
                        // add active dropzone feedback
                        dropzoneElement.classList.add('drop-active');
                    }
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;

                    // feedback the possibility of a drop
                    dropzoneElement.classList.add('drop-target');
                    draggableElement.classList.add('can-drop');
                },
                ondragleave: function (event) {
                    // remove the drop feedback style
                    event.target.classList.remove('drop-target');
                    event.relatedTarget.classList.remove('can-drop');
                },
                ondrop: function (event) {
                    var draggableElement = event.relatedTarget,
                        dropzoneElement = event.target;
                    var de = $(draggableElement);
                    var attrId = de.data('attributeid'),
                        type = de.data('attributetype');
                    var groupId = $(dropzoneElement).data('groupnr');

                    draggableElement.classList.remove('can-drop');
                    $('body').trigger('filterattribute-dropped', { attrId: attrId, type: type, groupId: groupId, dropzoneElement: dropzoneElement, draggableElement: draggableElement });
                },
                ondropdeactivate: function (event) {
                    // remove active dropzone feedback
                    event.target.classList.remove('drop-active');
                    event.target.classList.remove('drop-target');
                }
            });
        }

    });
})(jQuery, window);